import { render } from "./blog-article-edition-form.vue?vue&type=template&id=09d55eee"
import script from "./blog-article-edition-form.vue?vue&type=script&lang=js"
export * from "./blog-article-edition-form.vue?vue&type=script&lang=js"

import "./blog-article-edition-form.vue?vue&type=style&index=0&id=09d55eee&lang=scss"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__